
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

export interface HelpItem {
    id: string;
    category: 'getting-started' | 'virtual-try-on' | 'wardrobe' | 'account' | 'technical';
    questionKey: string;
    answerKey: string;
}

export const helpItems: HelpItem[] = [
    {
        id: 'gs-1',
        category: 'getting-started',
        questionKey: 'help_q_how_to_start',
        answerKey: 'help_a_how_to_start'
    },
    {
        id: 'vto-1',
        category: 'virtual-try-on',
        questionKey: 'help_q_accuracy',
        answerKey: 'help_a_accuracy'
    },
    {
        id: 'vto-2',
        category: 'virtual-try-on',
        questionKey: 'help_q_change_pose',
        answerKey: 'help_a_change_pose'
    },
    {
        id: 'wardrobe-1',
        category: 'wardrobe',
        questionKey: 'help_q_upload_clothes',
        answerKey: 'help_a_upload_clothes'
    },
    {
        id: 'wardrobe-2',
        category: 'wardrobe',
        questionKey: 'help_q_delete_item',
        answerKey: 'help_a_delete_item'
    },
    {
        id: 'acc-1',
        category: 'account',
        questionKey: 'help_q_reset_password',
        answerKey: 'help_a_reset_password'
    },
    {
        id: 'acc-2',
        category: 'account',
        questionKey: 'help_q_subscription',
        answerKey: 'help_a_subscription'
    },
    {
        id: 'tech-1',
        category: 'technical',
        questionKey: 'help_q_slow_generation',
        answerKey: 'help_a_slow_generation'
    }
];

// Helper to generate a text block for the AI Chatbot system prompt
// This allows the bot to answer support questions accurately based on the app's actual logic.
export const getSystemHelpContext = (t: (key: string) => string): string => {
    const qaPairs = helpItems.map(item => 
        `Q: ${t(item.questionKey)}\nA: ${t(item.answerKey)}`
    ).join('\n\n');

    return `
You are an expert support agent for the "Constantina Styling Advisor" app. 
Here is the official knowledge base of the application. Use this information to answer user questions about how to use the app.

--- APPLICATION KNOWLEDGE BASE ---

${qaPairs}

--- ADDITIONAL CONTEXT ---
- The "Canvas" is the central area where the model and outfit are displayed.
- The "Wardrobe" (Left Panel) is where users select garments.
- The "Outfit Stack" (Right Panel) is where users manage layers, remove items, or change colors.
- Users must upload a photo of themselves first to generate an AI Model.
- "Style Persona" is generated in the Profile page based on saved outfits.
----------------------------------
`;
};
